import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import { SIGNIN, SIGNOUT, SIGNUP } from "../constants/Auth";
import { showAuthMessage, authenticated } from "../actions/Auth";
import ApplicationService from "../../services/ApplicationService";
import { success } from "../actions";
import AuthService from "../../services/AuthService";
import {
  setSession,
  setUserSession,
} from "../../components/util-components/Session/Session";
import { BASEURL } from "configs/AppConfig";
import { BACKOFFICE_USER } from "configs/EnvironmentConfig";

export function* signIn() {
  yield takeEvery(SIGNIN, function* ({ payload }) {
    const { username, password } = payload;
    try {
      const res = yield call(AuthService.login, username, password);

      const { access_token, type } = res.data.data;

      setSession(access_token);

      //Check is a backoffice user or not
      // if (type == BACKOFFICE_USER) {
      const usr = yield call(AuthService.getUser, access_token);
      const { data } = usr;
      setUserSession(data);

      yield put(authenticated(access_token));
      // } else {
      // yield put(showAuthMessage("You are not a backoffice user"));
      // }
    } catch (error) {
      if (error.response) {
        if (error.response.status == 400) {
          yield put(
            showAuthMessage("Username of password invalid please try again")
          );
        } else if (error.response.status == 401) {
          yield put(
            showAuthMessage(
              "Invalid Client credentials please contact administrator"
            )
          );
        } else {
          yield put(showAuthMessage(error.toString()));
        }
      } else {
        yield put(showAuthMessage(error.toString()));
      }
    }
  });
}

export function* signOut() {
  yield takeEvery(SIGNOUT, function* () {
    try {
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export function* signUp() {
  yield takeEvery(SIGNUP, function* ({ payload }) {
    const { email, password } = payload;
    try {
    } catch (error) {
      yield put(showAuthMessage(error));
    }
  });
}

export default function* rootSaga() {
  yield all([fork(signIn), fork(signOut), fork(signUp)]);
}
